import React, { memo } from 'react';
import Button from '@atlaskit/button/standard-button';
import Modal, {
	ModalBody,
	ModalFooter,
	ModalHeader,
	ModalTitle,
	ModalTransition,
} from '@atlaskit/modal-dialog';
import { ShortcutScope } from '@atlassian/jira-common-components-keyboard-shortcuts';
import { useIntl } from '@atlassian/jira-intl';
import type { BoardIssueOld } from '../../../common/types';
import { useDeleteIssueAction } from '../../../controllers/delete-issue-old';
import messages from './messages';

type Props = {
	issue: BoardIssueOld | null;
	onClose: () => void;
};

const IssueDeleteModal = memo<Props>(({ issue, onClose }: Props) => {
	const onDelete = useDeleteIssueAction();
	const { formatMessage } = useIntl();

	return (
		<ModalTransition>
			{issue != null && (
				<ShortcutScope>
					<Modal width="small" onClose={onClose}>
						<ModalHeader>
							<ModalTitle appearance="danger">
								{formatMessage(messages.title, { itemKey: issue.key })}
							</ModalTitle>
						</ModalHeader>
						<ModalBody>
							<p>{formatMessage(messages.warning)}</p>
							<p>{formatMessage(messages.recommendation)}</p>
						</ModalBody>
						<ModalFooter>
							<Button appearance="subtle" onClick={onClose}>
								{formatMessage(messages.cancel)}
							</Button>
							<Button
								appearance="danger"
								onClick={() => {
									onDelete(issue);
									onClose();
								}}
								autoFocus
							>
								{formatMessage(messages.delete)}
							</Button>
						</ModalFooter>
					</Modal>
				</ShortcutScope>
			)}
		</ModalTransition>
	);
});

export default IssueDeleteModal;
